

<template>
  <div class="upload">
      <div class="upload-file">
         <input ref="uploadFile" @input="fireInput" @change="changeFiles()" type="file" multiple/>
         <img class="document" v-if="!urlImageReview" src="../assets/document.jpg" alt="document" />
         <span v-if="!urlImageReview" class="mb-5 mt-3 ml-3 mr-3 text-center">{{$t('providers.cop.upload_photo')}} {{label}}</span>
         <div v-if="isLoading" class="spinner-border">
            <span class="sr-only">Loading...</span>
         </div>
         <div v-else class="box-review">
             <img class="img-review" v-if="urlImageReview" :src="urlImageReview" alt="image review" />
             <!-- <span v-if="urlImageReview" class="pt-2 text-right close-icon" @click="removeOne(index)">X</span> -->
             <a v-if="urlImageReview"  @click="removeOne(index)" class="close text-right close-icon pt-2" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </a>
         </div>
      </div>
      <!-- <div v-if="preview && previewImages.length > 0">
         <div v-for="(item,index) in  previewImages" :key="item">
            <div class="file-info d-flex align-items-center justify-content-between">
               {{item}} -->
                <!-- {{item.name}} -->
               <!-- <span class="pt-2 text-right close-icon" @click="removeOne(index)">X</span>
            </div>
         </div>
      </div> -->
     <p  class="text-danger mt-2" v-if="error">You can upload maximum {{limit}} files.</p>
  </div>
</template>

<style scoped lang="scss">

.spinner-border{
   border: 2px solid currentColor;
   border-right-color: transparent;
   position: absolute;
   top: 43%;
   left: 47%;
   color: #ffbe17;
}

.box-review{
   display: contents;
}

.close-icon{
   position: absolute;
   right: 19px;
   top: 0px;
   cursor: pointer;
   z-index: 999;
   font-weight: bold;
   color: black;
   text-shadow: none;
   font-size: 35px;
   opacity: 1;
}

// .file-info{
//    width: 100%;
//    word-wrap: break-word; 
//    .close-icon{
//       display: none;
//       font-size: 20px;
//       &:hover{
//          cursor: pointer;
//       }
//    }
//    &:hover .close-icon{
//       display: inline-block;
//    }

// }

.upload-file {
    width:100%;
    display:flex;
    flex-direction: column;
    border: 1px dashed #C0C0C0;
    box-sizing: border-box;
    border-radius: 30px;
    align-items:center;
    position: relative;
    min-height: 408px;
    max-height: 408px;
}
.upload-file input{
  position: absolute;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  outline: none;
  opacity: 0;
}

.upload-file .document{
   width: 150px;
   height: 200px;
   margin-top: 70px;
}

.upload-file .img-review{
   // height: 310px;
   width: 100%;
   margin: auto;
   max-height: 408px;
   min-height: 408px;
   border-radius: 30px;
}

.upload-file p {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 100px;
  color: black;
}

</style>

<script>
export default {
   props: {
      preview:{
        type: Boolean,
        default: true
      },
      value: Array,
      label: String,
      limit:{
         type: Number,
         default: 5
      }
   },
   data(){
     return {
        files: '',
        error: false,
        previewImages: [],
        listImages: [],
        urlImageReview: "",
        isLoading: false
     }
   },
   methods: {
      reset(){
            this.previewImages = [];
            this.listImages = [];
            this.files = [];
            this.error = false;
            this.urlImageReview = "";
      },
      changeFiles(){
           this.reset();
           console.log(`event ${event.target.files}`);
            if(event.target.files && event.target.files.length > this.limit){
               this.reset();
               this.fireInput();
               return this.error = !this.error;
            }
            this.files = event.target.files && event.target.files.length > 0 ? event.target.files : null;
            if(this.files){
               this.files.forEach(async file =>{
                  console.log("file ", file);
                  this.previewImages.push(file.name);
                  this.urlImageReview = URL.createObjectURL(file);
                  await this.uploadImage(file);
               })
               // this.fireInput();
            }
            this.fireInput();
            console.log("Vao file nek", this.files);
            console.log("Vao file nek", this.previewImages);
          
      },
      async uploadImage(file){
            this.isLoading = true;
            let { _id, uploadUrl } = await this.$store.$oddjob.file.getImgConfig({ mineType: file.type});
            let result = await this.$store.$oddjob.file.uploadFile(uploadUrl, file);
            console.log("result uploadFile", result);
            this.listImages.push(_id);
            this.isLoading = false;
      },
      removeOne(index){
        this.listImages.splice(index, 1);
        this.previewImages.splice(index, 1);
        this.$refs.uploadFile.value = [];
        this.urlImageReview = "";
        this.fireInput();
      },
      fireInput(){
         var value = this.listImages;
         this.$emit("input", value);
      }
   }
}
</script>

